import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { MessageListener } from './message-listener';
export { MessageListener };
import { messageListenerSchema } from '@schemas/business-objects/message-listener';
import { TokenFormGroup } from './token-form-group';

export class MessageListenerFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    boundaryEventId: SchemaFormControl;
    messageName: SchemaFormControl;
    interrupting: SchemaFormControl;
    status: SchemaFormControl;
    completedAt: SchemaFormControl;
    createdAt: SchemaFormControl;
    updatedAt: SchemaFormControl;
    tokenId: SchemaFormControl;
    token: TokenFormGroup;
  };

  declare value: Partial<MessageListener>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(messageListenerSchema, MessageListener, data, options);
  }

  get object(): MessageListener {
    return new MessageListener(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'token':
        return new TokenFormGroup();
      default:
        return undefined;
    }
  }

  async trigger(options: any): Promise<any> {
    const instance = new MessageListener(this.value);
    return instance.trigger(options);
  }
}

export class MessageListenerFormArray extends PersistedFormArray {
  readonly entityName = 'MessageListener' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(messageListenerSchema, MessageListener, options);
  }

  protected override createItemGroup() {
    return new MessageListenerFormGroup();
  }

  get array(): MessageListener[] {
    return this.controls.map((group: MessageListenerFormGroup) => group.object);
  }
}

export class MessageListenerPersistedArray extends PersistedArray<MessageListener> {
  readonly entityName = 'MessageListener' as const;

  constructor(options?: PersistedArrayOptions) {
    super(MessageListener, options);
  }
}
